import LabelsStep from './LabelsStep';
import { withPopup } from './Utils';

export default withPopup(LabelsStep);
